export const headingWithHighlightStandard = {
  heading: 'Human Interest Learning Center',
  highlight: 'Human Interest',
};
